module.exports = __webpack_public_path__ + "src/assets/img/menu_icon_3_green.49298e3b.svg";